export default __webpack_public_path__ + "assets/18c7435ad5ee6306d2c2c18054a63c83.png";